import { ReportProblemOutlined } from "@mui/icons-material"
import { Box, Button, Link, List, ListItem, Typography } from "@mui/material"
import { AppSettings } from "../Utils/Settings"
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router";
import { useSendFallbackEmailMutation } from "../Redux/api/adminApi";
import { useUser } from "../Hooks/useUser";

interface IProps {
    error: any;
}

const FallbackPage = ({ error }:IProps) => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const { locator } = useUser();
    const [ sendFallbackEmail ] = useSendFallbackEmailMutation();
    /* ******************** Variables ******************** */
    const errorId = uuidv4();
    /* ******************** Functions ******************** */
    const handleClick = async () =>{
        if (AppSettings.NodeEnvironment != 'development') {
            await sendFallbackEmail({
                locator,
                error,
                errorId
            });
        }
        navigate('/dashboard');
        window.location.reload();
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    console.error(`Fallback error(${errorId}): ${error}`);
    return (
        <Box
            display='flex'
            flexDirection='column'
            justifyContent='center'
            alignItems='center'
            width={'100%'}
            height={'100%'}
            gap={1}
        >
            <ReportProblemOutlined color="primary" sx={{ fontSize: '80px'}}/>
            <Typography variant="title-large">Whoops! We Broke Something</Typography>
            <Typography variant="body-medium">We’re really sorry for the inconvenience! But don’t worry—we’ve got our best engineers on the case.</Typography>
            <Typography variant="body-medium">If you need a hand, reach out to our support team and include this error code so we can track it down:</Typography>
            <Typography variant="body-medium"><strong>Error ID:</strong> {errorId}</Typography>
            <Typography variant="body-medium">Support email: {AppSettings.SupportEmail}</Typography>
            <Button variant="contained" onClick={handleClick}>Return to the dashboard</Button>
        </Box>
    )
}

export default FallbackPage
